// 预约状态枚举（对齐接口：1已预约 2已取消）
export const AppointmentStatusEnum = {
  BOOKED: 1,    // 已预约
  CANCELLED: 2  // 已取消
};

// 状态显示配置（a-tag）
export const StatusConfig = {
  [AppointmentStatusEnum.BOOKED]: {
    text: '已预约',
    color: 'green'
  },
  [AppointmentStatusEnum.CANCELLED]: {
    text: '已取消',
    style: { backgroundColor: '#f5f5f5', color: '#666', border: '1px solid #d9d9d9' }
  }
};

// 状态筛选选项
export const StatusOptions = [
  { value: 1, label: '已预约' },
  { value: 2, label: '已取消' }
];

// 银行枚举（编码对齐接口：bank 1-5）
export const BankOptions = [
  { value: 1, label: '中国银行' },
  { value: 2, label: '浦发银行' },
  { value: 3, label: '北京农商银行' },
  { value: 4, label: '中国农业银行' },
  { value: 5, label: '北京银行' }
];

// 发展阶段枚举（编码对齐接口：developmentStage 1-13）
export const StageOptions = [
  { value: 1, label: '尚未融资' },
  { value: 2, label: '种子轮' },
  { value: 3, label: '天使轮' },
  { value: 4, label: 'Pre-A轮' },
  { value: 5, label: 'A轮' },
  { value: 6, label: 'B轮' },
  { value: 7, label: 'C轮' },
  { value: 8, label: 'D轮' },
  { value: 9, label: 'E轮及以后' },
  { value: 10, label: '战略融资' },
  { value: 11, label: 'IPO/上市' },
  { value: 12, label: '上市后融资' },
  { value: 13, label: '其他' }
];

// 表格列配置
export const TableColumns = [
  { title: '预约编号', dataIndex: 'appointmentNo', key: 'appointmentNo', width: 140, customRender: (text) => text || '-' },
  { title: '预约类型', dataIndex: 'typeName', key: 'typeName', width: 110, customRender: (text) => text || '-' },
  { title: '预约日期', dataIndex: 'appointmentDate', key: 'appointmentDate', width: 110, customRender: (text) => text || '-' },
  { title: '预约时段', dataIndex: 'slotsText', key: 'slotsText', width: 120, scopedSlots: { customRender: 'slotsText' } },
  { title: '预约人姓名', dataIndex: 'userName', key: 'userName', width: 100, customRender: (text) => text || '-' },
  { title: '手机号', dataIndex: 'phone', key: 'phone', width: 120, customRender: (text) => text || '-' },
  { title: '企业名称', dataIndex: 'companyName', key: 'companyName', width: 200, scopedSlots: { customRender: 'companyName' } },
  { title: '所属行业', dataIndex: 'industry', key: 'industry', width: 110, customRender: (text) => text || '-' },
  { title: '银行', dataIndex: 'bankDesc', key: 'bankDesc', width: 100, customRender: (text) => text || '-' },
  { title: '发展阶段', dataIndex: 'developmentStageDesc', key: 'developmentStageDesc', width: 100, customRender: (text) => text || '-' },
  { title: '来访类型', dataIndex: 'firstVisitDesc', key: 'firstVisitDesc', width: 90, customRender: (text) => text || '-' },
  { title: '人数', dataIndex: 'peopleNum', key: 'peopleNum', width: 70 },
  { title: '备注', dataIndex: 'remark', key: 'remark', width: 150, scopedSlots: { customRender: 'remark' } },
  { title: '状态', dataIndex: 'status', key: 'status', width: 90, scopedSlots: { customRender: 'status' } },
  { title: '预约时间', dataIndex: 'createTime', key: 'createTime', width: 160, customRender: (text) => text || '-' },
  { title: '取消时间', dataIndex: 'cancelTime', key: 'cancelTime', width: 160, customRender: (text) => text || '-' },
  { title: '操作', key: 'action', width: 200, fixed: 'right', scopedSlots: { customRender: 'action' } }
];
